"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function makeNext() {
    return function next(f) {
        setTimeout(f, 0);
    };
}
exports.default = makeNext();
